import { takeEvery, call, putResolve, select } from 'redux-saga/effects';
import {
  SET_CURRENT_STORE,
  SET_PILOT_STORE,
  UPDATE_THD_STORE_INFO,
} from '../actions/actionCreators';
import { getPilotStoreStatus } from '../api/storeInfoApi';
import { getHdmsStoreDetails, getStoreDetails } from '../selectors/thdStoreInfo';
import safeSaga from './safeSaga';

function* checkForPilotStoreFromLocalization() {
  try {
    const { storeNumber } = yield select(getStoreDetails);
    const data = yield call(getPilotStoreStatus, storeNumber);
    yield putResolve({ type: SET_PILOT_STORE, payload: data.pilot });
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Pilot store saga failed: ${err.message}`);
  }
}

function* checkForPilotStoreFromStoreSelector(action) {
  try {
    const { payload: { previousStoreId } } = action;
    const { storeInfo: { storeId } } = yield select(getHdmsStoreDetails);
    if (+storeId !== +previousStoreId) {
      const data = yield call(getPilotStoreStatus, storeId);
      yield putResolve({ type: SET_PILOT_STORE, payload: data.pilot });
    }
  } catch (err) {
    // eslint-disable-next-line no-console
    console.log(`Pilot store saga failed: ${err.message}`);
  }
}

export function* pilotStoreSaga() {
  yield takeEvery(UPDATE_THD_STORE_INFO, safeSaga(checkForPilotStoreFromLocalization));
  yield takeEvery(SET_CURRENT_STORE, safeSaga(checkForPilotStoreFromStoreSelector));
}
